import React from 'react';

import OriginalLinkify from 'react-linkify';

import Typography from 'src/components/ui/Typography';
import { colours } from 'src/constants/colours';
import { getFormattedMessageWithMentions } from 'src/utils/mentionsUtils';
import { styledComponent } from 'src/utils/styled';

const StyledTypography = styledComponent(Typography)<{
    $isMyMessage?: boolean;
}>`
    ${({ $isMyMessage }) =>
        !$isMyMessage &&
        `
        a {
            color: ${colours.secondary.main};
        }
    `}
`;

interface Props {
    content: string | React.ReactNode | React.ReactNode[];
    formatMentions?: boolean;
    isMyMessage?: boolean;
}

/**
 * Formats plain text URLs and user mentions as links.
 *
 * User mention links will open in the same tab.
 * Other links will open in a new tab or window.
 *
 * @remarks The user mentions can only be formatted when the content is a `string`.
 */
const Linkify: React.FC<Props> = ({ content, formatMentions, isMyMessage }) => (
    <OriginalLinkify
        // eslint-disable-next-line react/no-unstable-nested-components
        componentDecorator={(decoratedHref, decoratedText, key) => (
            <a key={key} target="_blank" rel="noopener noreferrer" href={decoratedHref}>
                {decoratedText}
            </a>
        )}
    >
        <StyledTypography $isMyMessage={isMyMessage} variant="body1">
            {formatMentions && typeof content === 'string' ? getFormattedMessageWithMentions(content) : content}
        </StyledTypography>
    </OriginalLinkify>
);

export default Linkify;
